import Cookies from "js-cookie";

export const setClientView = value => {
  Cookies.set("clientView", value);
  setTimeout(() => {
    window.location.replace("/");
  }, 100);
};

export const getClientView = () => {
  return Cookies.get("clientView") === "on";
};
